<template>
  <span class="new-live-embed">
    <h2 class="page-title">{{ $t('message.routesTitles.EmbedAndLink') }}</h2>

    <LiveEmbed v-bind="$attrs"/>

    <v-divider />
    <LiveLink class="d-block mb-6" v-bind="$attrs" />

  </span>
</template>

<script>
// external imports

// internal imports

// API

// Components
import LiveEmbed from './LiveEmbed.vue'
import LiveLink from './LiveLink.vue'

export default {
  name: 'NewLiveV2Embed',
  components: {
    LiveEmbed,
    LiveLink,
  },
}
</script>

<style lang="scss" scoped>
.new-live-embed {
  font-size: 1rem;
  color: var(--v-neutral-lighten1);

  &::v-deep {
    @import '@/assets/scss/src/new-live';
  }
}

.bg-dark {
  .new-live-embed {
    background-color: var(--v-neutral-darken2);
    color: white;
  }
 .page-title {
   color: var(--v-primary-base) !important
 }
}
</style>
